import { useRouter } from 'next/compat/router'
import { useMemo } from 'react'

export const useRegion = (): string | null => {
  const router = useRouter()

  const region = useMemo(() => {
    if (!router || !router.asPath) return null

    const segments = router.asPath.split('/')
    // example
    // ['', 'lp', 'en', 'cz', 'restaurantweek']
    if (segments.length >= 4) {
      return segments[3]
    }

    return null
  }, [router?.asPath])

  return region
}
